import { MAXIMUM_PURCHASE_VALUE_LENGTH } from 'Utilities/consts';

export const BID_INPUT_ID = 'bidInput';
export const BID_ERROR_MESSAGE_ID = 'bidErrorMessage';

const COMMAS_IN_MAX_NUMBER = 2;

const HIGHEST_SINGLE_NUMBER = 9;

export const MAXIMUM_PURCHASE_VALUE_LENGTH_WITHOUT_COMMA = MAXIMUM_PURCHASE_VALUE_LENGTH - COMMAS_IN_MAX_NUMBER;

export const MAX_BID_VALUE = Number(
	Array(MAXIMUM_PURCHASE_VALUE_LENGTH_WITHOUT_COMMA)
		.fill(`${HIGHEST_SINGLE_NUMBER}`)
		.reduce((acc) => `${acc}9`, ''),
);
